import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-legal-docs-alert',
  templateUrl: './legal-docs-alert.component.html',
  styleUrls: ['./legal-docs-alert.component.scss']
})
export class LegalDocsAlertComponent {

    alertData: any = {
      message:'Add missing legal documents. Default content is available for you to edit or save for display in your store.'
    };
  
    constructor() { }
  
    ngOnInit(): void {
    }

}
